import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { CollateralNotes } from "@app/models/collateral-notes";
import { CollateralNotesService } from "@app/services/collateral-notes.service";

@Component({
    selector: "app-collateral-note-node",
    templateUrl: "./collateral-note-node.component.html",
    styleUrls: ["./collateral-note-node.component.css"],
    standalone: false
})
export class CollateralNoteNodeComponent implements OnInit {
  @Input() level: number;
  @Input() collateralNotes: Array<CollateralNotes>;
  @Input() selectedCollateralNotes: Array<CollateralNotes>;
  @Output() onAddCollateralNote = new EventEmitter<CollateralNotes>();
  @Output() onDeleteCollateralNote = new EventEmitter<CollateralNotes>();

  constructor(private collateralNotesService: CollateralNotesService) {}

  ngOnInit(): void {}

  changeNoteStatus(item, value) {
    if (value.target.checked) {
      this.addCollateralNote(item);
    } else {
      this.deleteCollateralNote(item);
    }
  }

  addCollateralNote(item) {
    this.onAddCollateralNote.emit(item);
  }

  deleteCollateralNote(item) {
    this.onDeleteCollateralNote.emit(item);
  }

  isSelectedCollateralNote(item) {
    var parents = [];
    for (var i = 0; i < this.selectedCollateralNotes.length; i++) {
      var parents = parents.concat(this.collateralNotesService.findCollateralNoteParents(this.selectedCollateralNotes[i], this.collateralNotes));
    }
    var sParents = new Set(parents);
    return sParents.has(item);
  }
}
